export default __webpack_public_path__ + "static/media/dmd-blue-dmd.959e0888.svg";